export default __webpack_public_path__ + "static/media/rajWebReactFirebase.894dc4ac.png";